module.exports = __webpack_public_path__ + "static/media/scheme.243c233e.svg";